import { atom } from "jotai";

export const puntosAtom = atom([]);
export const loadingAtom = atom(false);
export const openModalRegistrarPuntosAtom = atom(false);
export const colaboradoresAtom = atom([]);
export const dnisNoProcesadosAtom = atom([])